/* eslint-disable @typescript-eslint/no-unused-vars */

import type { Input } from 'valibot';
import { boolean, email, literal, maxLength, minLength, nullable, number, object, omit, optional, regex, string, transformAsync, union, url } from 'valibot';
import type { Database } from './../types/supabase';


const userPermissionDBObject = object({
  user_id: string(),
  created_at: string(),
  updated_at: string(),
  subscription_active: boolean(),
})


const snsLinkValibot = optional(
  union([string([url("Invalid URL"),
  maxLength(1000, "sns error")
  ]), literal('')])
)


export const userProfileDBObject = object({

  /* 
  
    updated_at TIMESTAMPTZ DEFAULT now() */
  user_id: string(),
  business_type: optional(nullable(string())),
  postal_code: optional(nullable(string())),
  address: optional(nullable(string())),
  phone_number: optional(nullable(string())),
  representative_name: optional(nullable(string())),
  listing_status: optional(nullable(string())),
  capital: optional(nullable(number())),
  established_at: optional(nullable(string())),
  updated_at: string(),

})


export const userDBObject = object({
  id: string(),
  email: string([email("メールアドレスが不正です。")]),
  name:
    string([
      minLength(0, "名前は1文字以上で入力してください。"),
      maxLength(30, "名前は30文字以内で入力してください。"),
    ]),
  profile:
    (string([
      minLength(0, "プロフィールは1文字以上で入力してください。"),
      maxLength(300, "プロフィールは300文字以内で入力してください。"),
    ])),

  iconurl: optional(string()),
  coverurl: optional(string()),
  display_id: string([
    minLength(1, "表示IDは1文字以上で入力してください。"),
    maxLength(50, "表示IDは50文字以内で入力してください。"),
    regex(/^[a-zA-Z0-9_-]+$/, "表示IDは英数字、アンダースコア、ハイフンのみ使用可能です。"),
  ]),
  customer_id: string(),
  created_at: string(),
  updated_at: string(),
  main_color: string("メインカラーは必須です。", [
    minLength(0, "メインカラーは1文字以上で入力してください。"),
    maxLength(7, "メインカラーは7文字以内で入力"),
    regex(/^#[0-9a-fA-F]{6}$/, "メインカラーは16進数で入力してください。"),
  ]),
  public_posts_count: number(),
  posts_likes_count: number(),
  official_link: snsLinkValibot,
  facebook_link: snsLinkValibot,
  instagram_link: snsLinkValibot,
  x_link: snsLinkValibot,
  line_link: snsLinkValibot,
  youtube_link: snsLinkValibot,
  followers_count: number(),
  following_count: number(),
  comments_count: number(),
  mail_notification: boolean(),
  password_reset_required: boolean(),
})

const userWithPermissionsDBObject = object({
  ...userDBObject.entries,
  user_permissions: object({
    ...userPermissionDBObject.entries,
  }),
});

const subscriptionModel = object({
  customer_id: string(),
  finished_at: nullable(string()),
  id: string(),
  price_id: string(),
  started_at: string(),
  status: string(),
})

const invoiceModel = object({
  created_at: string(),
  customer_id: string(),
  due_date: nullable(string()),
  id: string(),
  price: number(),
  price_id: string(),
  status: string(),
})

export type UserPublicType = Input<typeof userPublicSchema>
export type UserDBObject = Input<typeof userDBObject>
export type SubscriptionModelType = Input<typeof subscriptionModel>
export type InvoiceModelType = Input<typeof invoiceModel>
export type UserPermissionDBObject = Input<typeof userPermissionDBObject>
type UserDb = Database["public"]["Tables"]["users"]["Row"]
type SubscriptionDb = Database["public"]["Tables"]["subscriptions"]["Row"]
type InvoiceDb = Database["public"]["Tables"]["invoices"]["Row"]
type UserPermissionDb = Database["public"]["Tables"]["user_permissions"]["Row"]
// 型の互換性を確認するダミー関数xz
function assertTypeCompatibility<A, B extends A>(): void { }
// 型チェックの実行
// assertTypeCompatibility<UserDBObject, UserDb>(); // display_idの型が更新されるまでコメントアウト

/* valibot 側で、空テキスト対策でoptionalをつけているので、
こっち側はなくてもいい */
//assertTypeCompatibility<UserDb, UserDBObject>();
assertTypeCompatibility<SubscriptionModelType, SubscriptionDb>();
assertTypeCompatibility<SubscriptionDb, SubscriptionModelType>();
assertTypeCompatibility<InvoiceModelType, InvoiceDb>();
assertTypeCompatibility<InvoiceDb, InvoiceModelType>();
assertTypeCompatibility<UserPermissionDBObject, UserPermissionDb>();
assertTypeCompatibility<UserPermissionDb, UserPermissionDBObject>();

export const pubUserModel = omit(userDBObject, ["email", "customer_id", "created_at", "updated_at",
  "mail_notification"
  , "password_reset_required"
])

export type PubUserType = Input<typeof pubUserModel>

export const userSchema = transformAsync(userDBObject,
  (input) => {
    return {
      ...input,
    };
  }
)
export const userProfileSchema = transformAsync(userProfileDBObject,
  (input) => {
    return {
      ...input,
    };
  }
)

export type UserSchemaType = Input<typeof userSchema>
export const userPermissionSchema = transformAsync(userWithPermissionsDBObject,
  (input) => {
    return {
      ...input,
    };
  }
)

export const userPublicSchema = transformAsync(pubUserModel,
  (input) => {
    return {
      ...input,
    };
  }
)

export const userPermitSchema = transformAsync(userPermissionDBObject,
  (input) => {
    return {
      ...input,
    };
  }
)


export const subscriptionSchema = transformAsync(subscriptionModel,
  (input) => {
    return {
      ...input,
    };
  }
)

export const invoiceSchema = transformAsync(invoiceModel,
  (input) => {
    return {
      ...input,
    };
  }
)

export const isNeverSns = (user: any) => {
  return user.facebook_link === "" && user.instagram_link === "" && user.x_link === "" && user.line_link === "" && user.youtube_link === ""
}